import React, { createContext, useState, useContext, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import httpClient from 'utility/httpClient.util'
import HoldBillDetails from 'components/Notifications/HoldBillDetails'
const PatientLockEditContext = createContext()

export const useLockEdit = () => useContext(PatientLockEditContext)

export const PatientLockEditProvider = ({ children }) => {
  const [isLocked, setIsLocked] = useState(false)
  const [isLockedFinance, setIsLockedFinance] = useState(false)
  const [eventMessage, setEventMessage] = useState()
  const [isLockedMedOPD, setIsLockedMedOPD] = useState(false)
  const [medOpdMessage, setMedOpdMessage] = useState()
  const requestVersionRef = useRef(0)
  const location = useLocation()
  const setLockStatus = (status) => {
    requestVersionRef.current += 1
    setIsLocked(status)
  }

  const setLockFinanceStatus = (status) => {
    setIsLockedFinance(status)
  }

  const setLockMedOPDStatus = (status) => {
    setIsLockedMedOPD(status)
  }

  const parseScreenUIAndHashQuery = () => {
    const hash = window.location.hash || ''
    const [path, queryString] = hash.split('?') // แยก path และ query

    const segments = path.split('/')
    const screenUI = segments[segments.length - 1] || ''

    // แปลง query string เป็น object
    const query = Object.fromEntries(new URLSearchParams(queryString || ''))

    return { screenUI, ...query } // ได้ทั้ง screenUI, vn, hn, etc.
  }

  useEffect(() => {
    let active = true
    setEventMessage()
    const load = async () => {
      const requestVersion = ++requestVersionRef.current
      //const params = new URLSearchParams(location.search);

      const hash = window.location.hash
      const queryString = location.search || hash.substring(hash.indexOf('?'))
      const params = new URLSearchParams(queryString)
      //console.log('qu',query.keys(),query.get('reportCode'),window.location)
      const hn = params.get('hn')
      const vn = params.get('vn')
      const an = params.get('an') || ''
      if (hn && vn) {
        try {
          const { screenUI } = parseScreenUIAndHashQuery()
          const result =
            (
              await httpClient.get(
                `/clinical/patient-lock-edit?hn=${hn}&vn=${vn}&an=${an}&screenUi=${screenUI}`,
                { cache: false },
              )
            )?.data || {}
          if (!active || requestVersion !== requestVersionRef.current) return
          const lockObj = result.data || []
          //console.log('lockObj',lockObj)
          let find = lockObj.find(
            ({ isLocked, moduleName }) =>
              isLocked * 1 === 1 && moduleName === 'ALL',
          )
          if (find) {
            setIsLocked(true)
          } else {
            setIsLocked(false)
          }
          find = lockObj.find(
            ({ isLocked, moduleName }) =>
              isLocked * 1 === 1 && moduleName === 'FINANCE',
          )
          if (find) {
            setIsLockedFinance(true)
            setEventMessage(
              <>
                รายการนี้ได้ทำการ{' '}
                <strong className="text-c-green">ชำระเงินเรียบร้อยแล้ว</strong>{' '}
                จึงไม่สามารถแก้ไขค่าบริการได้
                {lockObj.some(
                  ({ isLocked, moduleName }) =>
                    Number(isLocked) === 1 && moduleName === 'HOLD_BILL',
                ) && (
                  <HoldBillDetails
                    vn={vn}
                    refreshKey={location.key || location.pathname}
                  />
                )}
              </>,
            )
          } else {
            find = lockObj.find(
              ({ isLocked, moduleName }) =>
                isLocked * 1 === 1 && moduleName === 'HOLD_BILL',
            )
            if (find) {
              setIsLockedFinance(true)
              setEventMessage(
                <>
                  รายการนี้ได้ทำการ{' '}
                  <strong className="text-c-red">Hold Bill</strong>{' '}
                  จึงไม่สามารถแก้ไขค่าบริการได้
                  <HoldBillDetails
                    vn={vn}
                    refreshKey={location.key || location.pathname}
                  />
                </>,
              )
            } else {
              setIsLockedFinance(false)
              setEventMessage()
            }
          }

          find = lockObj.find(
            ({ isLocked, moduleName }) =>
              isLocked * 1 === 1 && moduleName === 'OPD_LOCK_MED',
          )
          if (find) {
            setIsLockedMedOPD(true)
            setMedOpdMessage(
              <>
                รายการยานี้ถูกบันทึกและ
                <strong className="text-c-green">
                  ส่งคิวเภสัชเรียบร้อยแล้ว
                </strong>{' '}
                หากต้องการแก้ไข รบกวนติดต่อเภสัชโดยตรง
              </>,
            )
          } else {
            setIsLockedMedOPD(false)
            setMedOpdMessage()
          }
        } catch (ex) {
          if (!active || requestVersion !== requestVersionRef.current) return
          setIsLocked(true)
          setIsLockedFinance(false)
          setIsLockedMedOPD(false)
        }
      } else {
        setIsLocked(false)
        setIsLockedFinance(false)
        setIsLockedMedOPD(false)
      }
    }
    const refresh = () => {
      if (document.visibilityState !== 'hidden') load()
    }

    load()
    window.addEventListener('focus', refresh)
    document.addEventListener('visibilitychange', refresh)
    return () => {
      active = false
      window.removeEventListener('focus', refresh)
      document.removeEventListener('visibilitychange', refresh)
    }
  }, [location])

  return (
    <PatientLockEditContext.Provider
      value={{
        isLocked,
        setLockStatus,
        isLockedFinance,
        setLockFinanceStatus,
        eventMessage,
        setEventMessage,
        isLockedMedOPD,
        setLockMedOPDStatus,
        medOpdMessage,
      }}
    >
      {children}
    </PatientLockEditContext.Provider>
  )
}
